import { render, staticRenderFns } from "./Break.vue?vue&type=template&id=569ec571&"
import script from "./Break.vue?vue&type=script&lang=js&"
export * from "./Break.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/Product.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports